import { FormInput, FormSelect, FormTextarea, Loader } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";

import { X } from "lucide-react";
import { capitalize } from "@/lib/utils";
import {
  COMPANY_DESC,
  COMPANY_NAME,
  companyOptions,
  EXP_REQ,
  JOB_DESC,
  JOB_ROLE,
  JOB_TITLE,
  LOCATION,
  REQ_SKILLS,
} from "./consts";

const AddEdit = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isView,
    onCancel,
    isAddPending,
    isMobile,
    action,
    isJobPostingDataLoading,
    isUpdatePending,
    keys,
    isEdit,
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6 lg:min-w-[500px] xl:min-w-[730px]">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              {capitalize(action || "")}
            </DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>
        {isJobPostingDataLoading ? (
          <Loader />
        ) : (
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[100px] lg:pb-[110px] px-1">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
                  <div className="col-span-2">
                    <FormInput
                      name={JOB_TITLE}
                      control={form.control}
                      label="Job Title"
                      placeholder="Please enter"
                      error={errors[JOB_TITLE]?.message}
                      isRequired={requiredFields.includes(JOB_TITLE)}
                      disabled={isView}
                    />
                  </div>
                  <FormInput
                    name={JOB_ROLE}
                    control={form.control}
                    label="Role"
                    placeholder="Please enter"
                    error={errors[JOB_ROLE]?.message}
                    isRequired={requiredFields.includes(JOB_ROLE)}
                    disabled={isView}
                  />
                  <FormSelect
                    key={keys.company}
                    name={COMPANY_NAME}
                    control={form.control}
                    label="Company"
                    placeholder="Please enter"
                    error={errors[COMPANY_NAME]?.message}
                    isRequired={requiredFields.includes(COMPANY_NAME)}
                    disabled={isView}
                    options={companyOptions}
                  />
                  <div className="col-span-2">
                    <FormTextarea
                      name={JOB_DESC}
                      control={form.control}
                      label="Job Description"
                      placeholder="Please enter"
                      error={errors[JOB_DESC]?.message}
                      isRequired={requiredFields.includes(JOB_DESC)}
                      disabled={isView}
                      className="min-h-10 max-h-22 resize"
                    />
                  </div>
                  <div className="col-span-2">
                    <FormTextarea
                      name={REQ_SKILLS}
                      control={form.control}
                      label="Skill Required"
                      placeholder="Please enter (semicolon separated)"
                      error={errors[REQ_SKILLS]?.message}
                      isRequired={requiredFields.includes(REQ_SKILLS)}
                      disabled={isView}
                      className="min-h-10 max-h-22 resize"
                    />
                  </div>
                  <div className="col-span-2">
                    <FormTextarea
                      name={EXP_REQ}
                      control={form.control}
                      label="Experience Required"
                      placeholder="Please enter (semicolon separated)"
                      error={errors[EXP_REQ]?.message}
                      isRequired={requiredFields.includes(EXP_REQ)}
                      disabled={isView}
                      className="min-h-10 max-h-22 resize"
                    />
                  </div>
                  <div className="col-span-2">
                    <FormTextarea
                      name={LOCATION}
                      control={form.control}
                      label="Location"
                      placeholder="Please enter (semicolon separated)"
                      error={errors[LOCATION]?.message}
                      isRequired={requiredFields.includes(LOCATION)}
                      disabled={isView}
                      className="min-h-10 max-h-22 resize"
                    />
                  </div>
                  <div className="col-span-2">
                    <FormTextarea
                      name={COMPANY_DESC}
                      control={form.control}
                      label="Company Introduction"
                      placeholder="Please enter"
                      error={errors[COMPANY_DESC]?.message}
                      isRequired={requiredFields.includes(COMPANY_DESC)}
                      disabled={isView}
                      className="min-h-10 max-h-22 resize"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-row justify-end gap-3 py-3 absolute bottom-0 right-0 w-full bg-white px-5 pb-[25px] z-[3]">
                <Button
                  variant="outline"
                  type="button"
                  onClick={onCancel}
                  disabled={isAddPending || isUpdatePending}
                >
                  Cancel
                </Button>
                {isView ? (
                  <></>
                ) : (
                  <Button
                    type="submit"
                    disabled={isAddPending || isUpdatePending}
                  >
                    {isAddPending ||
                      (isUpdatePending ? (
                        <Loader variant="secondary" />
                      ) : (
                        <></>
                      ))}
                    {isEdit ? "Update" : "Submit"}
                  </Button>
                )}
              </div>
            </form>
          </FormProvider>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default AddEdit;
